export const NETWORKLOADBALANCER = 'NETWORKLOADBALANCER'